import React, { useEffect, useState } from "react";
import CustomButtonOval from "../form/CustomButtonOval";

const BaseModalAnimated = ({ modal, setModal, children, headerRight, classModal, ...props }) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (modal.show) {
            setShowModal(true);
        }
    }, [modal.show]);

    const closeModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setModal({ ...modal, show: false, id: null });
        }, 300);
    };

    const classM = `relative w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-2xl mx-auto mt-12 ${classModal ?? ''}`;

    return modal.show ? (
        <>
            <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm transition-opacity duration-100"></div>
            <div className={`fixed inset-0 z-50 flex items-start justify-center overflow-x-hidden overflow-y-auto`}>
                <div
                    className={`${classM} transform transition-all duration-100 ${
                        showModal ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-4"
                    }`}
                >
                    <div className="relative flex flex-col w-full rounded-2xl shadow-xl bg-white/80 backdrop-blur-lg border border-fr-muted overflow-hidden">
                        {/* Header */}
                        <div className="flex items-center justify-between px-6 py-4 bg-fr-primary text-fr-light">
                            <h3 className="text-lg font-semibold">{modal.title}</h3>
                            <div className="flex items-center gap-2">
                                {headerRight && <div>{headerRight}</div>}
                                <button
                                    onClick={closeModal}
                                    className="text-fr-light hover:text-fr-muted transition-colors duration-200"
                                    aria-label="Cerrar modal"
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {/* Contenido */}
                        <div className="px-6 py-5 text-fr-dark">{children}</div>
                    </div>
                </div>
            </div>
        </>
    ) : null;
};

export default BaseModalAnimated;
